/** Класс табов. */
export class Tabs {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.tabsItem = this.el.querySelectorAll(".js-tabs-item");
        this.tabPanes = this.el.querySelectorAll(".js-tabs-pane");
        
        this.openContentOnClickTab();
    }

    /**
     * Прослушиваем клик на кнопку таба.
     * Сравниваем data-атрибуты у кнопки-таба и контента.
     * Присваиваем выбранному табу и контенту активные классы.
     * 
     * @returns {void}
     */
    openContentOnClickTab() {
        this.tabsItem.forEach((tabNav) => {
            tabNav.addEventListener("click", e => {
                if (tabNav.classList.contains("js-tabs-link")) {
                    return;
                }
                e.preventDefault();
                const activeTabAttr = tabNav.getAttribute("data-tab");

                this.tabPanes.forEach((tabPane, index) => {
                    const contentAttr = this.tabPanes[index].getAttribute("data-tab-content");
                    if (activeTabAttr === contentAttr) {
                        if (!tabNav.classList.contains("js-sidebar-item")) {
                            this.tabsItem[index].classList.add("tabs__item--active");
                        }
                        this.tabPanes[index].classList.add("tabs__pane--active"); 
                    } else {
                        this.tabsItem[index].classList.remove("tabs__item--active");
                        this.tabPanes[index].classList.remove("tabs__pane--active");
                    }
                })    
            })
        })
    }
}

window.addEventListener(
    "load",
    document
        .querySelectorAll(".js-tabs")
        .forEach(node => new Tabs(node))
);